import { z } from "zod"

export const ComposerModeEnum = {
  customer: "customer",
  resolver: "resolver",
} as const

export const ComposerModeSchema = z.enum(ComposerModeEnum)

export type ComposerMode = z.infer<typeof ComposerModeSchema>
